import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  Heading,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

interface IDetail {
  label: string;
  value: string;
  fontStyle: string;
}

interface Props {
  label: string;
  description: string;
  details?: IDetail[];
  isOpen: boolean;
}
interface EmitEvents {
  (event: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsModal',
  props: {
    label: null,
    description: null,
    details: null,
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {





return { __sfc: true,Modal, Heading, BaseText, ListDisplay, ButtonContainer, ButtonPrimary, Portal }
}

})